import React from 'react';

const MobileLayout = ({ children, styles }) => {
    // See DesktopLayout: `children` is a lone element (not an array) when the
    // caller passes exactly one child — ComposePage's `resolving` branch does
    // this while a triaged thought loads. Destructuring a single element throws
    // and white-screened the app. Normalize to an array first.
    const [navigationButton, thoughtEditor, actionButtons] =
        Array.isArray(children) ? children : [children];

    return (
        <div style={styles.composePage.mobile.container}>
            <div style={styles.composePage.mobile.header}>
                {navigationButton}
                <div style={styles.composePage.mobile.buttonContainer}>
                    {actionButtons}
                </div>
            </div>
            
            <div style={styles.composePage.mobile.textareaContainer}>
                {thoughtEditor}
            </div>
        </div>
    );
};

export default MobileLayout; 